import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { format } from 'date-fns';

export const RasporedDataTable = (props) => {
  const [raspored, setRaspored] = useState();
  const [expandedRows, setExpandedRows] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  useEffect( () => {
    setRaspored(props.data);
  }, [props.data]);

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span>{format(new Date(data.pocetak), 'dd.MM.yyyy.')}</span>
      </React.Fragment>
    );
  };

  const onCustomPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 25, value: 25 },
        { label: 50, value: 50 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Zapisa po stranici:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };

  const datumColumn = (aktivnost) => {
    return format(new Date(aktivnost.pocetak), 'HH:mm') + " - " + format(new Date(aktivnost.kraj), 'HH:mm');
  }
  const predmetColumn = (aktivnost) => {
    if( aktivnost.novi_naziv_predmeta !== null && aktivnost.novi_naziv_predmeta !== undefined){
      return aktivnost.novi_naziv_predmeta;
    } else {
      return aktivnost.naziv_predmeta;
    }
  }
  

  return (
    <div className="centerText">   
      <DataTable
        value={raspored}
        rowGroupMode="subheader"
        groupRowsBy="pocetak"
        responsiveLayout="scroll"
        expandableRowGroups
        stripedRows
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowGroupHeaderTemplate={headerTemplate}
        paginator
        paginatorTemplate={paginatorTemplate}
        first={first}
        rows={rows}
        onPage={onCustomPage}
        paginatorClassName="justify-content-end"
      >
        <Column
          header="Datum"
          body={ datumColumn }
          className="table-column-date"
        ></Column>
        <Column 
          header="Predmet"
          body={ predmetColumn }
          className="table-column-date"
        ></Column>
        <Column 
          field="opis"
          header="Opis"
          className="table-column-course"
        ></Column>
        <Column
          field="naziv_ucionice"
          header="Učionica"
          className="table-column-default"
        ></Column>
        <Column
          field="sati_predavanja"
          header="Broj sati"
          className="table-column-date"
        ></Column>
      </DataTable>
    </div>
    
  );
};

export default RasporedDataTable;
